<router-outlet></router-outlet>

@if (authService.showSessionExpire()) {
  <o-session-expired-component
  ></o-session-expired-component>
}
